import { PinEncryptionService } from '@eika-kortbetjening/pin-code';

import { postCardPin } from '@/react-query/services/pin';

import { CardType, KredittbankenViewPinSession, ViewPinSession } from '@generated-types';

import { getCreditCardViewPinSession, postCreditCardPin } from './queries/creditCardPin';

const encryptPin = async (
    { audit, activeCard, random, sgw, publicKey }: ViewPinSession,
    cardNumber: string,
    cardType: CardType,
    cardId: string,
) => {
    const pinObject = new PinEncryptionService(publicKey);
    const activeCardId = activeCard.replace(/\s+/g, '').slice(0, 16);
    const cardIsMatch = activeCardId === cardNumber;

    if (cardIsMatch) {
        const encryptedPinMessage = pinObject.generateEncryptedFetchPinMessage(random, activeCard);

        const postResponse = await postCardPin(audit, encryptedPinMessage, sgw, cardType, cardId);
        pinObject.set_encPin(postResponse.data);
        pinObject.decrypt_pin();
        return pinObject.clearPin;
    }

    return null;
};

const encryptCreditPin = async (
    { audit, activeCards, random, sgw, publicKey }: KredittbankenViewPinSession,
    cardNumber: string,
) => {
    const pinObject = new PinEncryptionService(publicKey);
    const unhinderedCardNumber = cardNumber.replace(/[x*\s]/g, '');
    const activeCard = activeCards.find((card) =>
        card
            .replace(/[x*\s]/g, '')
            .slice(0, 10)
            .includes(unhinderedCardNumber),
    );

    if (activeCard) {
        const encryptedPinMessage = pinObject.generateEncryptedFetchPinMessage(random, activeCard);

        const postResponse = await postCreditCardPin({ audit, data: encryptedPinMessage, sgw });
        pinObject.set_encPin(postResponse.data);
        pinObject.decrypt_pin();
        return pinObject.clearPin;
    }

    return null;
};

const getCreditCardPin = async (cardNumber: string) => {
    const viewPinSession = await getCreditCardViewPinSession();

    return encryptCreditPin(viewPinSession, cardNumber);
};

export const CardPinService = { encryptPin, getCreditCardPin };
